var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ui-dialog",
    { ref: "dialog", attrs: { title: "Storage", closable: "" } },
    [
      _c("p", [
        _vm._v(
          "Storage used (h:m:s): " + _vm._s(_vm._f("timecode")(_vm.storageSecs))
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }